/* eslint-disable react-hooks/exhaustive-deps */
import IconClose from "@mui/icons-material/Close";
import React, { useEffect, useRef, useState } from "react";
import "./fileInput.css";

function FileInput({
  onChange,
  name = "attachment",
  file = null,
  label = "Choose File",
  fileType = "image/png",
  disabled
}) {
  const inputRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  //use effects
  useEffect(() => {
    if (file === null) {
      onChange({
        target: {
          name: name,
          files: [null],
        },
      });
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [file]);

  return (
    <div className="file-input">
      <div className="file-input-left">
        {!isLoading && (
          <input
            type="file"
            accept={fileType}
            name={name}
            onChange={onChange}
            ref={inputRef}
          />
        )}

        <div className="file-input-filename">{file?.name || file}</div>
      </div>

      <div className="file-input-right">
        {file !== null && (
          <button
            onClick={() => {
              onChange({
                target: {
                  name: name,
                  files: [null],
                },
              });
              setIsLoading(true);
              setTimeout(() => {
                setIsLoading(false);
              }, 500);
            }}
            className="file-input-close-btn"
          >
            <IconClose fontSize="small" />
          </button>
        )}

        {file === null && !isLoading && (
          <button
            className="file-input-select-btn"
            onClick={() => {
              inputRef?.current?.click();
            }}
            disabled={disabled}
          >
            Choose File
          </button>
        )}
      </div>
      <div className="file-input-label">{label}</div>
    </div>
  );
}

export default FileInput;
